// src/components/js/LeftSidebar.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/LeftSidebar.css';
import { useAuth } from '../../context/AuthContext';

// UPDATED: all endpoints point to local backend
const API_ENDPOINTS = {
  Gene: 'http://197.156.76.122/api/gene/counts/',
  Nucleotide: 'http://197.156.76.122/api/nucleotide/counts/',
  Taxonomy: 'http://197.156.76.122/api/taxonomy/counts/',
  GenomeAssembly: 'http://197.156.76.122/api/genomeassembly/counts/',
  PubMed: 'http://197.156.76.122/api/pubmed/counts/',
  Protein: 'http://197.156.76.122/api/protein/counts/',
  Bookshelf: 'http://197.156.76.122/api/book/counts/',
  GeoDataset: 'http://197.156.76.122/api/geodata/counts/',
  BioAssay: 'http://197.156.76.122/api/bioassay/counts/',
  Pathway: 'http://197.156.76.122/api/pathway/counts/',
  Substance: 'http://197.156.76.122/api/substance/counts/',
  SRA: 'http://197.156.76.122/api/sra/counts/',
  BioProject: 'http://197.156.76.122/api/bioproject/counts/',
  BioSample: 'http://197.156.76.122/api/biosample/counts/',
  PMCArticle: 'http://197.156.76.122/api/pmc/counts/',
  ProteinFromUniProt: 'http://197.156.76.122/api/proteins/counts/',
};

const LeftSidebar = () => {
  const [counts, setCounts] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const { authTokens } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCounts = async () => {
      const updatedCounts = {};
      for (const key in API_ENDPOINTS) {
        try {
          const response = await axios.get(API_ENDPOINTS[key]);
          if (response.data) {
            if (key === 'GeoDataset') {
              const { series_count = 0, platform_count = 0, sample_count = 0 } = response.data;
              updatedCounts[key] = series_count + platform_count + sample_count;
            } else if (typeof response.data.count === 'number') {
              updatedCounts[key] = response.data.count;
            } else if (typeof response.data.total === 'number') {
              updatedCounts[key] = response.data.total;
            } else if (typeof response.data === 'number') {
              updatedCounts[key] = response.data;
            } else {
              updatedCounts[key] = 0;
            }
          } else {
            updatedCounts[key] = 0;
          }
        } catch (err) {
          console.error(`Failed to fetch count for ${key}`, err);
          updatedCounts[key] = 0;
        }
      }
      setCounts(updatedCounts);
    };
    fetchCounts();
  }, []);

  const handleSubmissionClick = () => {
    if (authTokens?.access) {
      navigate("/dataset-submissions");
    } else {
      navigate("/login?next=/dataset-submissions");
    }
  };

  const toggleDropdown = (title) => {
    setOpenDropdown(openDropdown === title ? null : title);
  };

  const renderDropdown = (title, items) => (
    <div className="dropdown-group">
      <div className="sidebar-link" onClick={() => toggleDropdown(title)}>
        {title}
      </div>
      <ul className={`dropdown-menu ${openDropdown === title ? 'open' : ''}`}>
        {items.map(({ to, label, count }) => (
          <li key={to}>
            <Link to={to}>
              {label} <span className="badge">{count ?? 0}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="left-sidebar">
      <div className="sidebar-title"><u><b>Data Centers</b></u></div>

      {renderDropdown("Literature", [
        { to: "/pubmed", label: "📰 PubMed", count: counts.PubMed },
        { to: "/book", label: "📖 Bookshelf", count: counts.Bookshelf },
        { to: "/pmc", label: "📚 PubMed Central", count: counts.PMCArticle },
      ])}

      {renderDropdown("Genomes", [
        { to: "/genomeassembly", label: "🧬 Assembly", count: counts.GenomeAssembly },
        { to: "/bioproject", label: "📂 BioProject", count: counts.BioProject },
        { to: "/biosample", label: "🧫 BioSample", count: counts.BioSample },
        { to: "/nucleotide", label: "🧪 Nucleotide", count: counts.Nucleotide },
        { to: "/sra", label: "📊 SRA", count: counts.SRA },
        { to: "/taxonomy", label: "🌱 Taxonomy", count: counts.Taxonomy },
      ])}

      {renderDropdown("Genes", [
        { to: "/gene", label: "🧬 Gene", count: counts.Gene },
        { to: "/geodata", label: "📈 GEO Datasets", count: counts.GeoDataset },
      ])}

      {renderDropdown("Protein", [
        { to: "/protein", label: "Protein Sequences (NCBI)", count: counts.Protein },
        { to: "/proteins", label: "From UniProt", count: counts.ProteinFromUniProt },
      ])}

      {renderDropdown("PubChem", [
        { to: "/bioassay", label: "🧪 BioAssays", count: counts.BioAssay },
        { to: "/pathway", label: "🧬 Pathways", count: counts.Pathway },
        { to: "/substance", label: "🧫 Substances", count: counts.Substance },
      ])}

      <div className="submission-link">
        <button onClick={handleSubmissionClick} className="submission-button">
          📤 Data Submission
        </button>
      </div>
    </div>
  );
};

export default LeftSidebar;
